import { render, staticRenderFns } from "./Day.vue?vue&type=template&id=54e52668&scoped=true"
import script from "./Day.vue?vue&type=script&lang=js"
export * from "./Day.vue?vue&type=script&lang=js"
import style0 from "./Day.vue?vue&type=style&index=0&id=54e52668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e52668",
  null
  
)

export default component.exports